export enum MediaTypes {
	AI = 'AI_GENERATED',
	USER = 'USER_UPLOADED',
}
